import {connect} from 'react-redux'
import styles from './List.css'
import InfiniteScroll from 'react-infinite-scroller'
import {categoriesRequest, onClickRow, onClickAssignToIngredient} from 'actions/ingredients/category'
import NoDataAndLoading from 'components/NoDataAndLoading'
import {isDirty} from 'redux-form'
import {askConfirmAction} from 'actions/confirm-action'

class List extends React.Component {
  render () {
    const {categories, categoryDetail, showLoadingSpinnerPage} = this.props
    if (categories.length > 0) {
      return <div className={styles['wrapper']}>
        <table className={styles['table-header']}>
          <thead>
            <tr>
              <th>Ingredient Category Name</th>
              <th>Ingredient Stocks</th>
              <th />
            </tr>
          </thead>
        </table>
        <div className={`${styles['table-content-wrapper']} ingredient-categories-table-content-wrapper`}>
          <InfiniteScroll
            pageStart={1}
            loadMore={this._onReachBottom}
            hasMore={this._hasMore()}
            useWindow={false}
            threshold={10}
            initialLoad={false}
          >
            <table className={`${styles['table-content']}`}>
              <tbody>
                {categories.map((category) => {
                  const className = (categoryDetail && category.id === categoryDetail.id) ? styles.selected : ''
                  return <tr onClick={() => { this._onClickRow(category) }} className={className}>
                    <td>{category.name}</td>
                    <td>{category.ingredient_count} ingredients</td>
                    <td className='text-right'>
                      <a
                        className='btn btn-default'
                        onClick={(event) => this._onClickAssignToIngredient(event, category)}>
                        Assign to Ingredient
                      </a>
                    </td>
                  </tr>
                })}
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>
    } else {
      return <NoDataAndLoading
        showLoadingSpinner={showLoadingSpinnerPage}
        noDataToDisplay={categories.length === 0}
        title='No Data To Display'
        description=''
        linkLabel='Create Ingredient Categories'
        linkUrl='https://mokaposhelp.zendesk.com/hc/en-us/articles/115004530194-Create-Ingredient-Categories'
      />
    }
  }

  _hasMore = () => {
    const {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

  _onReachBottom = () => {
    const {dispatch, currentPage, categories} = this.props
    dispatch(categoriesRequest({page: currentPage + 1}, categories))
  }

  _onClickRow = (category) => {
    const {dispatch, isDirtyForm} = this.props
    if (isDirtyForm) {
      dispatch(askConfirmAction(onClickRow(category)))
    } else {
      dispatch(onClickRow(category))
    }
  }
  _onClickAssignToIngredient = (event, category) => {
    event.preventDefault()
    event.stopPropagation()
    this.props.dispatch(onClickAssignToIngredient(category))
  }
}

function mapStateToProps (state) {
  const {categories, totalPage, currentPage, categoryDetail} = state.ingredients.category
  const {showLoadingSpinnerPage} = state.loadingSpinner
  return {
    categories,
    totalPage,
    currentPage,
    showLoadingSpinnerPage,
    categoryDetail,
    isDirtyForm: isDirty('ingCategory')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Category/List/List.js